import React, { useState } from "react";
import { RadioButtonChecked } from "@mui/icons-material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Button,
  FormControl,
  Menu,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Box, Flex, Label, Text } from "@100mslive/roomkit-react";
import FullPageProgress from "../../FullPageProgress";
import { ToastManager } from "../../Toast/ToastManager";
import AccountStockAddPopup from "./AccountStockAddPopup";
import { SESSION_AUTH } from "../../../common/auth";
import { EXCHANGE_SERVICES } from "../../../services";

const AccountStock = props => {
  const { orgStocks, setOrgPublic, orgPublic, isEditAccess, onUpdate } = props;
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [loading, setLoading] = useState(false);
  const [addNewStock, setAddNewStock] = useState(false);

  const onSave = () => {
    setLoading(true);
    EXCHANGE_SERVICES.stockNo({
      userId: isUserSession.userId,
      org: isUserSession?.org?.id,
    })
      .then(data => {
        if (data.code === 200) {
          onUpdate();
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({
          title: err?.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const rowAction = Boolean(anchorEl);

  const openRowAction = event => {
    setAnchorEl(event.currentTarget);
  };

  const closeRowAction = () => {
    setAnchorEl(null);
  };

  const onRemove = item => {
    setAnchorEl(null);
    setLoading(true);
    EXCHANGE_SERVICES.stockRemove({
      userId: isUserSession.userId,
      org: isUserSession?.org?.id,
      exchange: item?.exchange,
      symbol: item?.symbol,
    })
      .then(data => {
        if (data.code === 200) {
          onUpdate();
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({
          title: err?.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onPrimary = item => {
    setAnchorEl(null);
    setLoading(true);
    EXCHANGE_SERVICES.stockPrimary({
      userId: isUserSession.userId,
      org: isUserSession?.org?.id,
      exchange: item?.exchange,
      symbol: item?.symbol,
    })
      .then(data => {
        if (data.code === 200) {
          onUpdate();
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({
          title: err?.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="events-page-account-setting-content-row">
      {loading && <FullPageProgress fixed={true} />}
      <Box className="events-page-account-setting-content-box">
        <div className="events-page-account-setting-content-box-title">
          Company Type
        </div>
        <FormControl className="events-page-account-setting-content-box-control custom-form-group">
          <Label
            htmlFor="org-public"
            className="events-page-account-setting-content-box-lable"
          >
            Is it a public company
          </Label>

          <Select
            id="org-public"
            name="orgPublic"
            className="custom-select"
            value={orgPublic || ""}
            readOnly={!isEditAccess}
            onChange={e => {
              if (isEditAccess) setOrgPublic(e.target.value);
            }}
            displayEmpty
          >
            <MenuItem disabled value="">
              <span>Select</span>
            </MenuItem>
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </Select>
        </FormControl>
        {orgPublic === "yes" ? (
          <>
            <Table sx={{ minWidth: 550 }} aria-label="post table">
              <TableHead>
                <TableRow>
                  <TableCell>Stock Exchange</TableCell>
                  <TableCell>Ticker</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {orgStocks?.length > 0 ? (
                  orgStocks?.map((row, key) => (
                    <TableRow
                      key={key}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell component="th">
                        {row?.exchange} ({row?.country})
                      </TableCell>
                      <TableCell component="th">{row?.symbol}</TableCell>

                      <TableCell align="center">
                        {row?.primary ? (
                          <RadioButtonChecked
                            className="text-primary"
                            title="Primary ticker"
                          />
                        ) : isEditAccess ? (
                          <div>
                            <Button
                              id={`stocks-dropdown-button-${key}`}
                              aria-controls={
                                rowAction
                                  ? `stocks-dropdown-menu-${key}`
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={rowAction ? "true" : undefined}
                              onClick={e => openRowAction(e)}
                            >
                              <MoreHorizIcon />
                            </Button>
                            <Menu
                              id={`stocks-dropdown-menu-${key}`}
                              aria-labelledby={`stocks-dropdown-menu-${key}`}
                              anchorEl={anchorEl}
                              open={rowAction}
                              onClose={closeRowAction}
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                            >
                              <MenuItem
                                onClick={() => {
                                  onPrimary(row);
                                }}
                              >
                                Make Primary
                              </MenuItem>

                              <MenuItem
                                onClick={() => {
                                  onRemove(row);
                                }}
                              >
                                Remove
                              </MenuItem>
                            </Menu>
                          </div>
                        ) : null}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" align="center" colSpan={3}>
                      <Button
                        color="primary"
                        variant="outlined"
                        className="events6ix-btn events6ix-btn-primary"
                        type="button"
                        onClick={() => setAddNewStock(true)}
                      >
                        Add Stock exchange
                      </Button>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            {orgStocks?.length > 0 && isEditAccess ? (
              <>
                <div className="events-page-account-setting-content-box-line"></div>
                <Flex
                  align="center"
                  className="events-page-account-setting-content-box-row"
                >
                  <Text
                    css={{
                      flex: "1 1 0",
                    }}
                    className="events-page-account-setting-content-box-text"
                  >
                    &nbsp;
                  </Text>

                  <Button
                    color="primary"
                    variant="outlined"
                    className="events6ix-btn events6ix-btn-primary"
                    type="button"
                    onClick={() => setAddNewStock(true)}
                  >
                    Add new
                  </Button>
                </Flex>
              </>
            ) : null}
          </>
        ) : isEditAccess ? (
          <>
            <div className="events-page-account-setting-content-box-line"></div>
            <Flex
              align="center"
              className="events-page-account-setting-content-box-row"
            >
              <Text
                css={{
                  flex: "1 1 0",
                }}
                className="events-page-account-setting-content-box-text"
              >
                &nbsp;
              </Text>

              <Button
                color="primary"
                variant="outlined"
                className="events6ix-btn events6ix-btn-primary"
                type="button"
                onClick={() => onSave()}
              >
                Save
              </Button>
            </Flex>
          </>
        ) : null}
      </Box>
      {addNewStock && isEditAccess ? (
        <AccountStockAddPopup
          onClose={() => {
            setAddNewStock(false);
          }}
          onUpdate={() => {
            setAddNewStock(false);
            onUpdate();
          }}
        />
      ) : null}
    </div>
  );
};

export default AccountStock;
